import { render, staticRenderFns } from "./ycoin.vue?vue&type=template&id=7a582fc0&"
import script from "./ycoin.vue?vue&type=script&lang=js&"
export * from "./ycoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports